import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=420c03a2&scoped=true&"
import script from "./Showcase.vue?vue&type=script&lang=js&"
export * from "./Showcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420c03a2",
  null
  
)

export default component.exports